"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebrtcConnector = exports.EARLY_TIMEOUT = exports.replaceInternalIpWithExternalIp = void 0;
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const ListeningRpcCommunicator_1 = require("../../transport/ListeningRpcCommunicator");
const NodeWebrtcConnection_1 = require("./NodeWebrtcConnection");
const WebrtcConnectorRpcRemote_1 = require("./WebrtcConnectorRpcRemote");
const DhtRpc_client_1 = require("../../../generated/packages/dht/protos/DhtRpc.client");
const utils_1 = require("@streamr/utils");
const Err = __importStar(require("../../helpers/errors"));
const WebrtcConnectorRpcLocal_1 = require("./WebrtcConnectorRpcLocal");
const identifiers_1 = require("../../identifiers");
const offering_1 = require("../../helpers/offering");
const Handshaker_1 = require("../Handshaker");
const version_1 = require("../../helpers/version");
const PendingConnection_1 = require("../PendingConnection");
const logger = new utils_1.Logger(module);
const replaceInternalIpWithExternalIp = (candidate, ip) => {
    const parsed = candidate.split(' ');
    const type = parsed[7];
    if (type === 'host') {
        parsed[4] = ip;
    }
    return parsed.join(' ');
};
exports.replaceInternalIpWithExternalIp = replaceInternalIpWithExternalIp;
exports.EARLY_TIMEOUT = 5000;
class WebrtcConnector {
    static WEBRTC_CONNECTOR_SERVICE_ID = 'system/webrtc-connector';
    rpcCommunicator;
    ongoingConnectAttempts = new Map();
    localPeerDescriptor;
    stopped = false;
    options;
    constructor(options) {
        this.options = options;
        this.rpcCommunicator = new ListeningRpcCommunicator_1.ListeningRpcCommunicator(WebrtcConnector.WEBRTC_CONNECTOR_SERVICE_ID, options.transport, {
            rpcRequestTimeout: 15000 // TODO use options option or named constant?
        });
        this.registerLocalRpcMethods(options);
    }
    registerLocalRpcMethods(options) {
        const localRpc = new WebrtcConnectorRpcLocal_1.WebrtcConnectorRpcLocal({
            connect: (targetPeerDescriptor, doNotRequestConnection) => this.connect(targetPeerDescriptor, doNotRequestConnection),
            onNewConnection: (connection) => this.options.onNewConnection(connection),
            ongoingConnectAttempts: this.ongoingConnectAttempts,
            rpcCommunicator: this.rpcCommunicator,
            getLocalPeerDescriptor: () => this.localPeerDescriptor,
            allowPrivateAddresses: options.allowPrivateAddresses ?? true
        });
        this.rpcCommunicator.registerRpcNotification(DhtRpc_1.WebrtcConnectionRequest, 'requestConnection', async (_req, context) => {
            if (!this.stopped) {
                return localRpc.requestConnection(context);
            }
            else {
                return {};
            }
        });
        this.rpcCommunicator.registerRpcNotification(DhtRpc_1.RtcOffer, 'rtcOffer', async (req, context) => {
            if (!this.stopped) {
                return localRpc.rtcOffer(req, context);
            }
            else {
                return {};
            }
        });
        this.rpcCommunicator.registerRpcNotification(DhtRpc_1.RtcAnswer, 'rtcAnswer', async (req, context) => {
            if (!this.stopped) {
                return localRpc.rtcAnswer(req, context);
            }
            else {
                return {};
            }
        });
        this.rpcCommunicator.registerRpcNotification(DhtRpc_1.IceCandidate, 'iceCandidate', async (req, context) => {
            if (!this.stopped) {
                return localRpc.iceCandidate(req, context);
            }
            else {
                return {};
            }
        });
    }
    connect(targetPeerDescriptor, doNotRequestConnection) {
        if ((0, identifiers_1.areEqualPeerDescriptors)(targetPeerDescriptor, this.localPeerDescriptor)) {
            throw new Err.CannotConnectToSelf('Cannot open WebRTC Connection to self');
        }
        logger.trace(`Opening WebRTC connection to ${(0, identifiers_1.toNodeId)(targetPeerDescriptor)}`);
        const nodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        const existingConnection = this.ongoingConnectAttempts.get(nodeId);
        if (existingConnection) {
            return existingConnection.managedConnection;
        }
        const connection = this.createConnection(targetPeerDescriptor);
        const localNodeId = (0, identifiers_1.toNodeId)(this.localPeerDescriptor);
        const targetNodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        const offering = ((0, offering_1.getOfferer)(localNodeId, targetNodeId) === 'local');
        let pendingConnection;
        const remoteConnector = new WebrtcConnectorRpcRemote_1.WebrtcConnectorRpcRemote(this.localPeerDescriptor, targetPeerDescriptor, this.rpcCommunicator, DhtRpc_client_1.WebrtcConnectorRpcClient);
        const delFunc = () => {
            this.ongoingConnectAttempts.delete(nodeId);
            connection.off('disconnected', delFunc);
            pendingConnection.off('disconnected', delFunc);
            pendingConnection.off('connected', delFunc);
        };
        if (offering) {
            pendingConnection = new PendingConnection_1.PendingConnection(targetPeerDescriptor);
            (0, Handshaker_1.createOutgoingHandshaker)(this.localPeerDescriptor, pendingConnection, connection, targetPeerDescriptor);
            connection.once('localDescription', (description) => {
                logger.trace('Sending offer to remote peer');
                remoteConnector.sendRtcOffer(description, connection.connectionId);
            });
        }
        else {
            pendingConnection = new PendingConnection_1.PendingConnection(targetPeerDescriptor);
            const handshaker = (0, Handshaker_1.createIncomingHandshaker)(this.localPeerDescriptor, pendingConnection, connection);
            connection.once('localDescription', (description) => {
                remoteConnector.sendRtcAnswer(description, connection.connectionId);
            });
            handshaker.on('handshakeRequest', (_sourceDescriptor, remoteVersion) => {
                if (!(0, version_1.isMaybeSupportedProtocolVersion)(remoteVersion)) {
                    (0, Handshaker_1.rejectHandshake)(pendingConnection, connection, handshaker, DhtRpc_1.HandshakeError.UNSUPPORTED_PROTOCOL_VERSION);
                }
                else {
                    (0, Handshaker_1.acceptHandshake)(handshaker, pendingConnection, connection);
                }
                delFunc();
            });
        }
        this.ongoingConnectAttempts.set(targetNodeId, {
            managedConnection: pendingConnection,
            connection
        });
        connection.on('disconnected', delFunc);
        pendingConnection.on('disconnected', delFunc);
        pendingConnection.on('connected', delFunc);
        connection.on('localCandidate', (candidate, mid) => {
            if (this.options.externalIp !== undefined) {
                candidate = (0, exports.replaceInternalIpWithExternalIp)(candidate, this.options.externalIp);
                logger.debug(`onLocalCandidate injected external ip ${candidate} ${mid}`);
            }
            remoteConnector.sendIceCandidate(candidate, mid, connection.connectionId);
        });
        connection.start(offering);
        if (!doNotRequestConnection && !offering) {
            remoteConnector.requestConnection();
        }
        return pendingConnection;
    }
    createConnection(targetPeerDescriptor) {
        return new NodeWebrtcConnection_1.NodeWebrtcConnection({
            remotePeerDescriptor: targetPeerDescriptor,
            iceServers: this.options.iceServers,
            bufferThresholdLow: this.options.bufferThresholdLow,
            bufferThresholdHigh: this.options.bufferThresholdHigh,
            portRange: this.options.portRange
            // TODO should we pass maxMessageSize?
        });
    }
    setLocalPeerDescriptor(peerDescriptor) {
        this.localPeerDescriptor = peerDescriptor;
    }
    async stop() {
        logger.trace('stop()');
        this.stopped = true;
        const attempts = Array.from(this.ongoingConnectAttempts.values());
        await Promise.allSettled(attempts.map(async (conn) => {
            conn.connection.destroy();
            conn.managedConnection.close(false);
        }));
        this.rpcCommunicator.destroy();
    }
}
exports.WebrtcConnector = WebrtcConnector;
//# sourceMappingURL=WebrtcConnector.js.map